import WebsiteMessageManager from './WebsiteMessageManager';

export default WebsiteMessageManager;
